import Vue from "vue"

import Notification from "vue-notification"
import Tooltip from "v-tooltip"
import Modal from "vue-js-modal"
import Buefy from "buefy"
import VuePageTransition from "vue-page-transition"
import Loading from "vue-loading-overlay"
import Vs from "d3-vs"
import Api from "./api"
import Format from "./format"
import VueClipboard from "vue-clipboard2"

Vue.use(Notification)
Vue.use(Tooltip)
Vue.use(Modal, { dialog: true, dynamic: true })
Vue.use(Buefy)
Vue.use(VuePageTransition)
Vue.use(Vs)
Vue.use(Loading)
Vue.use(VueClipboard)
declare module "vue/types/vue" {
    interface Vue {
        $loading: any
    }
}
Vue.use(Api)
Vue.use(Format)

export default Vue
